export default function pxToEm(px: number, base = 16) {
  return `${px / base}em`;
}
